import React, { useContext, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { AuthContext } from 'src/context/AuthContext'

const ClientLoginStatus = () => {
  const { clientData, selectedClientId } = useContext(AuthContext)
  const [, setOpenClientList] = useState(false)

  const handleOpenClientList = () => {
    setOpenClientList(true)
  }

  //   useEffect(() => {
  //   if (clientData) {
  //     //console.log('clientData updated:', clientData)
  //   }

  // }, [clientData])

  const filteredClients = clientData?.clients?.filter(client => client.clientId === selectedClientId) || []

  if (!clientData?.clients) {
    return <Typography>No clients available</Typography>
  }

  return (
    <div>
      <Grid>
        {filteredClients.map(client => {
          return (
            <Grid item xs={12} sm={6} md={4} key={client.clientId}>
              <div
                onClick={handleOpenClientList}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '40px',
                  width: 'auto',
                  gap: '8px',
                  cursor: 'pointer'
                }}
              >
                {/* {client.image ? (
                  <img
                    src={`data:image/png;base64,${client.image}`}
                    alt={client.clientName}
                    style={{
                      width: 25,
                      height: 25,
                      borderRadius: '50%'
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: 27,
                      height: 27,
                      borderRadius: '50%',
                      backgroundColor: '#666cff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#fff'
                    }}
                  >
                    {client.clientName ? client.clientName.charAt(0).toUpperCase() : '?'}
                  </div>
                )} */}
                <Typography
                  sx={{
                    fontSize: '16px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100px',
                    color: '#fff',
                    textTransform: 'capitalize',
                    letterSpacing: '0.7px',
                    '@media (max-width: 1600px)': {
                      fontSize: '12.5px',
                      maxWidth: '80px'
                    },
                    '@media (max-width: 599.95px)': {
                      fontSize: '12px',
                      maxWidth: '56px',
                      letterSpacing: '0.3px'
                    }
                  }}
                >
                  {client.clientName}
                </Typography>
              </div>
            </Grid>
          )
        })}
      </Grid>
      {/* {isMultipleClients && (
        <LoginClientList
           openClientList={openClientList}
          handlecloseClientList={handleCloseClientList}
          clientData={clientData}
          selectedClientId={selectedClientId}
          setSelectedClientId={setSelectedClientId}
          handleLoginClient={handleLoginClient}
          tempAuthToken={tempAuthToken}
        />
      )} */}
    </div>
  )
}

// ClientLoginStatus.propTypes = {
//   clientData: PropTypes.shape({
//     clients: PropTypes.arrayOf(
//       PropTypes.shape({
//         clientId: PropTypes.string.isRequired,
//         clientName: PropTypes.string.isRequired,
//         image: PropTypes.string,
//       })
//     ).isRequired,
//   }).isRequired,
// };

export default ClientLoginStatus
